export const ADD_ENTITIES = 'crush/entities/ADD_ENTITIES'
const SET_LOADING = 'crush/app/SET_LOADING'
const SHOW_ERROR = 'crush/app/SHOW_ERROR'
const SHOW_ERROR_AD = 'crush/app/SHOW_ERROR_AD'
const HIDE_ERROR = 'crush/app/HIDE_ERROR'

const initialState = {
  isLoading: true,
  showError: false,
  showErrorAd: false,
  errorMessage: ''
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        isLoading: action.isLoading
      }

    case SHOW_ERROR:
      return {
        ...state,
        showError: true,
        errorMessage: action.errorMessage
      }

    case SHOW_ERROR_AD:
      return {
        ...state,
        showErrorAd: true
      }

    case HIDE_ERROR:
      return {
        ...state,
        showError: false,
        errorMessage: ''
      }

    default:
      return state
  }
}

export const addEntities = entities => ({
  type: ADD_ENTITIES,
  entities
})

export const setLoading = isLoading => ({
  type: SET_LOADING,
  isLoading
})

export const showFetchError = () => ({
  type: SHOW_ERROR,
  errorMessage: 'There was an error when trying to contact our server. Please close this window and try again.'
})

export const showErrorAd = () => ({
  type: SHOW_ERROR_AD
})

export const showSdkError = () => ({
  type: SHOW_ERROR,
  errorMessage: 'Failed to load data from Facebook. Please close this window and try again.'
})

export const hideError = () => ({
  type: HIDE_ERROR
})



// WEBPACK FOOTER //
// ./src/lib/store/app.js